import officesEdit from './edit.vue'
import officesList from './list.vue'
import officesInfo from './info.vue'

import * as buildFloor from './buildFloor'


let a = Object.assign({ officesEdit, officesList,officesInfo},buildFloor)
export default a
